import Api from 'libs/api/index';
import axios from 'axios';
import AuthService from '../../services/Auth';

class InterviewStorePoolsApi extends Api {
  constructor() {
    super('interviews/interview_store_pools/');
  }

  getExcelSingle = (id) => {
    return axios({
      url: `${this.url.slice(0, -1)}/${id}.xlsx`,
      method: 'get',
      data: {},
      params: {},
      responseType: 'blob', // important
      headers: {
        'Content-Type': 'application/json',
        'auth-token': AuthService.getToken(),
      },
    });
  };

  answerQuestions = (id, params) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/interviews/interview_store_pool_answers`,
      method: 'post',
      data: params.data,
      params: {},
      headers: {
        'Content-Type': 'application/json',
        'auth-token': AuthService.getToken(),
      },
    });
  };
}

export default InterviewStorePoolsApi;
